// Public, stable download links for the Terac desktop app (TrajectoryCapture).
//
// These are the `installers/latest/*` aliases on the public-read S3 releases bucket
// (terac-trajectory-capture repo: infra/terraform/releases.tf, published by
// .github/workflows/release.yml, ENG-569). The GitHub repo is private, so the GitHub
// Release isn't reachable for beta panelists. These S3 objects are the only public
// first-time-install path. The `latest` alias is overwritten on every release, so the
// link is stable and always points at the newest signed + notarized build.
//
// The auto-updater handles every subsequent update in-app, so users only need these
// links once.

const RELEASES_BASE_URL =
  "https://terac-releases-014071048974.s3.us-east-1.amazonaws.com/installers/latest";

export interface DownloadTarget {
  /** Public S3 download URL. */
  href: string;
  /** Short note clarifying which machines this build is for. */
  note?: string;
}

export const MACOS_DOWNLOADS: Record<"appleSilicon" | "intel", DownloadTarget> =
  {
    appleSilicon: {
      href: `${RELEASES_BASE_URL}/Terac_macos_aarch64.dmg`,
      note: "M1, M2, M3 and newer",
    },
    intel: {
      href: `${RELEASES_BASE_URL}/Terac_macos_x86_64.dmg`,
      note: "Older Intel-based Macs",
    },
  };

export const WINDOWS_DOWNLOAD: DownloadTarget = {
  href: `${RELEASES_BASE_URL}/Terac_windows_x64-setup.exe`,
  note: "Windows 10 and 11 (64-bit)",
};

/** Minimum supported OS versions (from the Tauri bundle config). */
export const MIN_MACOS_VERSION = "macOS 13 Ventura";
export const MIN_WINDOWS_VERSION = "Windows 10";
